
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }


  if(Flits.Metafields.IS_STORE_CREDIT_PAID && Flits.Metafields.is_store_credit_enable && window.flitsObjects.storeData.customer_id != -1){
    Flits.LoadStyleScript('cartJs',window.flitsObjects.allCssJs.cartJs.url);
  }
  
  if(Flits.customer_id != -1){
    Flits(document).on("click", 'input[name="checkout"]', function (event) {
      event.preventDefault(); 
      event.stopPropagation();
      event.stopImmediatePropagation();
      var submitBtn = this;
      var url = [Flits.base_url, Flits.customer_id].join("/") + "/delete-discounts";
      Flits.ajax({ url: url, method: "post", data: { customer_hash: Flits.customerHash, token:Flits.token } });

      setTimeout(function(){ 
        if(Flits('#dc_valid_discount').val() != '' && Flits('#dc_valid_discount').val() != undefined){
          location.href = '/checkout?discount='+Flits('#dc_valid_discount').val();
        }else{
          location.href = '/checkout?discount=+'; 
        }
      }, 500);
      return false;
    });
  }
  //  BELOW FUNCTION MOVES CREDIT TAB TO FIRST SLIDE IN MOBILE **START**
  function moveInArray(arr, from, to) {
    // Make sure a valid array is provided
    if (Object.prototype.toString.call(arr) !== '[object Array]') {
      throw new Error('Please provide a valid array');
    }
    // Delete the item from it's current position
    var item = arr.splice(from, 1);
    // Make sure there's an item to move
    if (!item.length) {
      throw new Error('There is no item in the array at index ' + from);
    }
    // Move the item to its new position
    arr.splice(to, 0, item[0]);
  };

  Flits(document).on('Flits:Navigation:Loaded', function(event){
    function mediaFunction(x) {
      if (x.matches) { // If media query matches
        var settings = event.detail.settings;
        moveInArray(settings.navs, 9, 1);
      } else {
        console.log("Desktop");
      }
    }
    var x = window.matchMedia("(max-width: 760px)")
    mediaFunction(x) // Call listener function at run time
    x.addListener(mediaFunction)
  });
  /////////   **END**  /////////

  // Refer Friend Page JS
  
  Flits(document).on('Flits:Navigation:Loaded', function(event){
    var settings = event.detail.settings;
    var obj = {
      title: 'Refer Friend',
      url:'/pages/refer-friend',
      target:0,
      badge: null,
      icon: '<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 16.62 16"><path id="Layer_2" data-name="Layer 2" d="M8.75,15.8H8.34v-.88h.07a5.87,5.87,0,0,0,6.38-4.57l-.11.09-.57-.66,1-.85.29-.24.31.27.91.9-.63.62-.27-.27A6.73,6.73,0,0,1,8.75,15.8ZM7.66,1.68l-.11.09.54.69,1-.81.31-.24-.22-.34L8.5,0,7.77.48,8,.8A6.81,6.81,0,0,0,1,6.91L1.46,7,1,6.9l.46.1H1.9A5.85,5.85,0,0,1,7.66,1.68ZM16,8a3.63,3.63,0,0,0-2.69-3.44h0a2.13,2.13,0,1,0-1.9,0h0A3.64,3.64,0,0,0,8.71,8v.44H16ZM11.63,5.42l.72-.19.71.19a2.76,2.76,0,0,1,2,2.16H9.63A2.78,2.78,0,0,1,11.63,5.42Zm2-2.76a1.24,1.24,0,0,1-.7,1.11l-.55.28-.56-.28a1.24,1.24,0,0,1-.7-1.11,1.26,1.26,0,0,1,2.51,0ZM7.28,15.55a3.64,3.64,0,0,0-2.63-3.41,2.11,2.11,0,0,0,1.13-1.87,2.14,2.14,0,0,0-4.27,0,2.11,2.11,0,0,0,1.13,1.87A3.64,3.64,0,0,0,0,15.55V16H7.29ZM2.93,13l.71-.2.72.2a2.76,2.76,0,0,1,2,2.15H.93A2.76,2.76,0,0,1,2.93,13Zm2-2.7a1.24,1.24,0,0,1-.7,1.11l-.56.28-.55-.28a1.24,1.24,0,0,1-.7-1.11,1.26,1.26,0,0,1,2.51,0Z"></path></svg>',
      isShow: 1,
      loader:null,
      body_html: ''
    }
    settings.navs.splice(14, 0, obj);

    let navigation = event.detail.settings.navs;
     event.detail.settings.navs = navigation.filter(function(value,key){
      return value.url !== "#referFriend"   
     })
  });

  // Flits.ajax({
  //     method: "GET",
  //     url: Flits.base_url + '/' + Flits.customer_id + "/credit/get_credit",
  //     data: {
  //         customer_hash: Flits.customerHash,
  //         token: Flits.token
  //     }
  // }).done((function(resp) {
  //   var data = resp;
  //   Flits(".earned_credit_value").append("Rs. " + data.customer.credits * 0.01) 
  //   Flits(".spent_credit_value").append("Rs. " + data.customer.total_spent_credits * (-0.01))
  //   Flits(".balance_credit_value").append("Rs. " + data.customer.total_earned_credits * 0.01)
  // }))

  if(Flits.Metafields.IS_REFER_PROGRAM_ON && Flits.Metafields.customer_id != -1){
  Flits.ajax({
      method: "GET",
      url: Flits.base_url + '/' + Flits.customer_id + "/refer_friend/get_referral_data",
      data: {
          customer_hash: Flits.customerHash,
          token: Flits.token
      }
    }).done((function(resp) {
    var data = resp;    
    Flits(".total_ref_value").append(data.reached_referral_limit)
    
  }))

  
    var customer_name = window.flitsCustomerName;
    var referal_link = parseInt(Flits.customer_id).toString(36);
    var share_link = "https://" + location.host + "/account/register?flits_refer_code=" + encodeURIComponent(unescape(btoa(referal_link))) + "&flits_inviter_name=" + encodeURIComponent(unescape(btoa(customer_name)));
    var abc = Flits(".flits_ref_link_div .flits-input").attr("value", share_link);
  }
  Flits(".copy_item .flits_ref_link_div .flits-copy-btn").html("Copy Link");

  Flits(document).on('click', '.flits-copy-btn', (function() {
    Flits.copyClipBoardCode(this);
    flitsSnackbar.show({
      text: Flits.t('Flits.locals.refer_friend_page.referral_link_copied', 'Link Copied'),
      pos: 'bottom-center',
      showAction: false,
      customClass: 'flits-alert-default',
      duration: 1500
    })
  }));

  Flits(document).on('click', ".flits-share-btn", (function(event) {
      let platform = Flits(this).attr('data-flits-share-platform');
      let referralLink = Flits('input[name="referral link"]').val();
      let facebookDescription = encodeURIComponent(unescape(Flits.t('Flits.locals.refer_friend_page.referral_program_invitation_message', 'You can earn credit for creating an account with {{ shop_name }}. Use this link and get rewarded : {{ link }}').replace("{{ link }}", '').replace("{{ shop_name }}", Flits.shop_name)));
      let encodedDescription = encodeURIComponent(unescape(Flits.t('Flits.locals.refer_friend_page.referral_program_invitation_message', 'You can earn credit for creating an account with {{ shop_name }}. Use this link and get rewarded : {{ link }}').replace("{{ link }}", referralLink).replace("{{ shop_name }}", Flits.shop_name)));
      let description = Flits.t('Flits.locals.refer_friend_page.referral_program_invitation_message', 'You can earn credit for creating an account with {{ shop_name }}. Use this link and get rewarded : {{ link }}').replace("{{ link }}", referralLink).replace("{{ shop_name }}", Flits.shop_name);
      let url = null;
      switch(platform) {
          case 'facebook':
              url = "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(unescape(referralLink)) + "&quote=" + facebookDescription;
              break;
          case 'whatsapp':
              url = "https://api.whatsapp.com/send?text=" + encodedDescription;
              break;
          case 'navigator_share':
              var data = {
                  title: 'Refer Freind',
                  text: description
              };
              let sharePromise = navigator.share(data);
              return true;
              break;
          default:
          case 'facebook':
              break
      }
      if(url) {
          Flits.popupWindow(url, platform.charAt(0).toUpperCase() + platform.slice(1) + " Share", window, 700, 700)
      }
  }));

  setTimeout(function() {
    Flits(".header_refer_links .flits-share-btn-grp").css("visibility","visible")
  }, 500);

  // Flits(document).on("click", ".ref_points_main .point_1", (function (event) {
  //   Flits(".ref_points_main .point_1").css("background","#1A9060")
  //   Flits(".ref_points_main .point_2").css("background","#D9D9D9")
  //   Flits(".ref_points_main .point_3").css("background","#D9D9D9")
  //   Flits(".ref_points_main .point_4").css("background","#D9D9D9")
  //   Flits(".ref_points_main .ref_points_text_2").css("visibility","hidden");
  //   Flits(".ref_points_main .ref_points_text_3").css("visibility","hidden");
  //   Flits(".ref_points_main .ref_points_text_4").css("visibility","hidden");
  //   Flits(".ref_credits_text .ref_track_line").css("background","linear-gradient(to bottom, #1A9060 0%, #D9D9D9 0%)")
  // }));
  
  // Flits(document).on("click", ".ref_points_main .point_2", (function (event) {
  //   Flits(".ref_points_main .point_1").css("background","#1A9060")
  //   Flits(".ref_points_main .point_2").css("background","#1A9060")
  //   Flits(".ref_points_main .point_3").css("background","#D9D9D9")
  //   Flits(".ref_points_main .point_4").css("background","#D9D9D9")
  //   Flits(".ref_points_main .ref_points_text_2").css("visibility","visible");
  //   Flits(".ref_points_main .ref_points_text_3").css("visibility","hidden");
  //   Flits(".ref_points_main .ref_points_text_4").css("visibility","hidden");
  //   if(Flits(window).width()<=394.99){
  //     Flits(".ref_credits_text .ref_track_line").css("background","linear-gradient(to bottom, #1A9060 29%, #D9D9D9 0%)")
  //   }
  //   else{
  //     Flits(".ref_credits_text .ref_track_line").css("background","linear-gradient(to bottom, #1A9060 35%, #D9D9D9 0%)")
  //   }
  // }));
  
  // Flits(document).on("click", ".ref_points_main .point_3", (function (event) {
  //   Flits(".ref_points_main .point_1").css("background","#1A9060")
  //   Flits(".ref_points_main .point_2").css("background","#1A9060")
  //   Flits(".ref_points_main .point_3").css("background","#1A9060")
  //   Flits(".ref_points_main .point_4").css("background","#D9D9D9")
  //   Flits(".ref_points_main .ref_points_text_2").css("visibility","visible");
  //   Flits(".ref_points_main .ref_points_text_3").css("visibility","visible");
  //   Flits(".ref_points_main .ref_points_text_4").css("visibility","hidden");
  //   if(Flits(window).width()<=394.99){
  //     Flits(".ref_credits_text .ref_track_line").css("background","linear-gradient(to bottom, #1A9060 62%, #D9D9D9 0%)")
  //   }
  //   else{
  //     Flits(".ref_credits_text .ref_track_line").css("background","linear-gradient(to bottom, #1A9060 66%, #D9D9D9 0%)")
  //   }
  // }));
  
  // Flits(document).on("click", ".ref_points_main .point_4", (function (event) {
  //   Flits(".ref_points_main .point_1").css("background","#1A9060")
  //   Flits(".ref_points_main .point_2").css("background","#1A9060")
  //   Flits(".ref_points_main .point_3").css("background","#1A9060")
  //   Flits(".ref_points_main .point_4").css("background","#1A9060")
  //   Flits(".ref_points_main .ref_points_text_2").css("visibility","visible");
  //   Flits(".ref_points_main .ref_points_text_3").css("visibility","visible");
  //   Flits(".ref_points_main .ref_points_text_4").css("visibility","visible");
  //   Flits(".ref_credits_text .ref_track_line").css("background","linear-gradient(to bottom, #1A9060 0%, #D9D9D9 500%)")
  // }));
  
}(Flits));
